import React, { useState } from 'react'
import { IMaskInput } from 'react-imask'
import { cpf } from 'cpf-cnpj-validator'

const CpfInput = ({ disabled = false, label, name, value, onChange, required = false }) => {
  const [error, setError] = useState(false)

  const handleAccept = (val) => {
    onChange({ target: { name, value: val } })
  }

  const handleBlur = () => {
    const numeric = value.replace(/\D/g, '')
    if (!numeric) return setError(false)
    setError(!cpf.isValid(numeric))
  }

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={name} className="text-lg text-blueDarker font-normal">
          {label}{required && <span className="ml-1.5">*</span>}
        </label>
      )}
      <IMaskInput
        id={name}
        name={name}
        required={required}
        disabled={disabled}
        value={value}
        mask="000.000.000-00"
        onAccept={handleAccept}
        onBlur={handleBlur}
        className={`w-full border rounded-xl px-3 py-3 text-base placeholder-blueSteel ${error ? 'border-red-500' : 'border-bluePale'}`}
        placeholder=""
      />
      {error && <span className="text-red-500 text-sm">CPF inválido</span>}
    </div>
  )
}

export default CpfInput
